export default [
    {
      path: '/house-pin/lists',
      name: 'house-pin-list',
      component: () => import('@/views/house-pin/house-pin-list/HousePinList.vue'),
      meta: {
        resource: 'House Pin',
        action: 'read',
      },
    },
    {
        path: '/house-pin/add',
        name: 'house-pin-create',
        component: () => import('@/views/house-pin/house-pin-form/HousePinForm.vue'),
        meta: {
            resource: 'House Pin',
            action: 'create',
        },
    },
    {
      path: '/house-pin/edit/:id',
      name: 'house-pin-edit',
      component: () => import('@/views/house-pin/house-pin-form/HousePinForm.vue'),
      meta: {
        resource: 'House Pin',
        action: 'update',
      },
    },
    {
      path: '/house-pin/floor-plan/:id',
      name: 'house-pin-floor-plan',
      component: () => import('@/views/house-pin/house-floor-plan/HousePinFloorPlan.vue'),
      meta: {
        resource: 'House Pin',
        action: 'update',
      },
    },
    {
      path: '/house-pin/upload/:id',
      name: 'house-pin-upload',
      component: () => import('@/views/house-pin/house-pin-upload/HousePinUpload.vue'),
      meta: {
        resource: 'House Pin',
        action: 'update',
      },
    },
]